import Decimal from 'decimal.js';

export default {
  /**
   * 加法运算
   * @param a 运算数1
   * @param b 运算数2
   */
  add: function (a: number | string, b: number | string): number {
    return new Decimal(a).add(new Decimal(b)).toNumber();
  },
  /**
   * 减法运算
   * @param a 运算数1
   * @param b 运算数2
   */
  subtract: function (a: number | string, b: number | string): number {
    return new Decimal(a).sub(new Decimal(b)).toNumber();
  },
  /**
   * 乘法运算
   * @param a 运算数1
   * @param b 运算数2
   */
  multiply: function (a: number | string, b: number | string): number {
    return new Decimal(a).mul(new Decimal(b)).toNumber();
  },
  /**
   * 除法运算
   * @param a 运算数1
   * @param b 运算数2
   */
  divide: function (a: number | string, b: number | string): number {
    return new Decimal(a).div(new Decimal(b)).toNumber();
  },
  /**
   * 四舍五入（原生四舍五入存在精度丢失的问题）
   * @param n 目标数字
   * @param decimal 需要保留的小数位数
   */
  toFixed: function (n: number | string, decimal: number) {
    return new Decimal(n).toFixed(decimal);
  }
};
